import React from 'react';
import { connectDeep } from 'redux-utils';
import styled from 'styled-components';

import { mapPageLayoutItems } from 'components/DiscoveryPage/utils';
import { AppType, RoutePaths } from '../../constants';
import { DiscoveryEntry } from '../../components/v2/Discovery/DiscoveryEntry';
import HomeContainer from '../../components/v2/HomeContainer';
import { getType, getPageType } from '../../utils.v2';
import { Transition } from '../../components/v2/Transition';
import { ScrollContainer } from '../../components/v2/ScrollContainer';
import i18n from '../../i18n';

export const FULL_VH = document.documentElement.clientHeight;

const Container = styled.div`
  height: ${FULL_VH - 64}px;
  background: var(--sys-color--surface);
`;

const mapStateToProps = (state: any) => {
  let { isApp, isNeutral, isTile, isClock } = getType(state.location);
  if (isNeutral) {
    // the location has changed, but the new page was not rendered, yet
    // the GalleryPage is still rendered so we must make sure we render the one that is already displayed
    isApp = getType(state.location.prev).isApp;
  }

  let pageLayoutType = getPageType({ isApp, isClock, isTile })

  const {
    installed: {
      error: installedError,
    },
    fetchPageLayout: { loading: fetchPageLayoutLoading },
    pageLayoutItems: {
      [pageLayoutType]: pageLayoutItems = [],
    },
    galleryGrant: { userHasGrant, loading: loadingHasGalleryGrant },
    features: { flags }
  } = state.registry;

  const {
    direction,
    deeplinkStatus: { isOpen: deeplinkIsOpen }
  } = state.gallery;

  const loading =
    fetchPageLayoutLoading ||
    loadingHasGalleryGrant ||
    deeplinkIsOpen ||
    pageLayoutItems.length === 0;

  const error = installedError;

  return {
    loading,
    error,
    pageLayoutItems: mapPageLayoutItems(pageLayoutItems, state),
    direction,
    userHasGalleryGrant: userHasGrant,
    isApp,
    isClock,
    isTile,
    showSearch: flags?.showSearch || false
  };
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface GalleryPageProps extends ReduxProps {

}

class GalleryPage extends React.Component<GalleryPageProps> {
  state = {
    scrollKey: ''
  };

  getScrollKey() {
    if (this.props.isApp) {
      this.setState({ scrollKey: 'appsPage' });
    } else {
      if (this.props.isClock) {
        this.setState({ scrollKey: 'clocksPage' });
      } else {
        this.setState({ scrollKey: 'tilesPage' });
      }
    }
  }

  private renderBody() {
    const { pageLayoutItems, userHasGalleryGrant, isApp, isTile, isClock, showSearch } = this.props;

    const viewName = getPageType({ isApp, isClock, isTile })
    return (
      <ScrollContainer
        navbarHeight={64}
        scrollKey={this.state.scrollKey}
      >
        <Container>
          <DiscoveryEntry
            pageLayoutItems={pageLayoutItems}
            userHasGalleryGrant={userHasGalleryGrant}
            isClock={isClock}
            appType={isTile ? AppType.TILE : AppType.APP}
            showSearch={showSearch}
          />
        </Container>
      </ScrollContainer>
    )
  }

  componentWillMount() {
    this.getScrollKey();
  }

  render() {
    const { loading, error, isApp, isClock, isTile } = this.props;

    let title = '';
    let discoverRoute;
    if (isClock) {
      title = i18n('page.ClockGallery.listPageName')();
      discoverRoute = RoutePaths.DISCOVER_CLOCKS;
    } else if (isApp) {
      title = i18n('page.AppGallery.listPageName')();
      discoverRoute = RoutePaths.DISCOVER_APPS;
    } else if (isTile) {
      title = 'Tiles';
      discoverRoute = RoutePaths.DISCOVER_TILES;
    }

    return (
      <HomeContainer selected={discoverRoute} centerTitle={title}>
        {
          loading || error ?
            <Transition loading={loading} error={error} headerHeight={64} /> :
            this.renderBody()
        }
      </HomeContainer>
    );
  }

}

export default connectDeep(mapStateToProps)(GalleryPage);
